import { ProductPromotionInfoInterface } from '@qlevr/shared/interfaces';
import { MetaobjectFieldShopify } from '@qlevr/shared/schema';
import { getMetafieldReferenceFields } from './get-metafield-reference-fields';

export function getProductPromotionInfo(
  fields: MetaobjectFieldShopify[] | null | undefined,
): ProductPromotionInfoInterface | null {
  if (!fields || fields.length === 0) {
    return null;
  }

  const title = getMetafieldReferenceFields('title', fields);
  const subtitle = getMetafieldReferenceFields('subtitle', fields);
  const showInfoMessage = getMetafieldReferenceFields('show_info_message', fields) === 'true';
  const infoMessage = getMetafieldReferenceFields('info_message', fields);
  const showInBasket = getMetafieldReferenceFields('show_in_basket', fields) === 'true';

  return {
    title,
    subtitle,
    showInfoMessage,
    infoMessage,
    showInBasket,
  };
}
